import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper } from './styles';

function MultiColumnLayout({
  sectionId,
  className,
  children,
  as,
  columns,
  spacing,
}) {
  if (!children) return null;
  return (
    <Wrapper
      id={sectionId}
      as={as}
      className={[className, `columns-${columns}`]}
      columns={columns}
      spacing={spacing}
    >
      {children}
    </Wrapper>
  );
}

MultiColumnLayout.propTypes = {
  className: PropTypes.string,
  sectionId: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  columns: PropTypes.number,
  spacing: PropTypes.string,
  as: PropTypes.string,
};

MultiColumnLayout.defaultProps = {
  className: null,
  columns: 3,
  spacing: '18px',
  as: 'div',
  sectionId: null,
};

export default MultiColumnLayout;
